export default "__VITE_ASSET__124dae2d__"